import TypesenseError from "./TypesenseError";

export default class ObjectAlreadyExists extends TypesenseError {}
